var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollToTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 21.7598C14.2487 21.7598 14.451 21.682 14.6065 21.5264C14.7621 21.3709 14.8398 21.1687 14.8398 20.9198V10.7464L18.6665 14.4798C18.791 14.6664 18.9776 14.7598 19.2265 14.7598C19.4754 14.7598 19.6932 14.682 19.8798 14.5264C20.0665 14.3709 20.1598 14.1687 20.1598 13.9198C20.1598 13.6709 20.0665 13.4531 19.8798 13.2664L14.6532 8.03977C14.4665 7.8531 14.2487 7.75977 13.9998 7.75977C13.751 7.75977 13.5332 7.8531 13.3465 8.03977L8.11984 13.2664C7.93318 13.4531 7.83984 13.6709 7.83984 13.9198C7.83984 14.1687 7.93318 14.3709 8.11984 14.5264C8.30651 14.682 8.52429 14.7598 8.77318 14.7598C9.02207 14.7598 9.20873 14.6664 9.33318 14.4798L13.1598 10.7464V20.9198C13.1598 21.1687 13.2376 21.3709 13.3932 21.5264C13.5487 21.682 13.751 21.7598 13.9998 21.7598Z",
    fill: "#003946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollToTop);
export default __webpack_public_path__ + "static/media/scrollToTop.ebfea6ec94cd1413db14b6d4dd7e7d9d.svg";
export { ForwardRef as ReactComponent };